import * as React from "react";
import { connect } from "react-redux";
import IProps from "./IProps";
import ReviewCard from "./component/reviewCard";
import * as myCartActionCreators from "../actionCreators";
import { bindActionCreators } from "redux";
/**
 * @Interface IState
 * @description This class will basically be used to show more details page
 * @ignore
 */
interface IState {
    items: any;
}
/**
 * @class ReviewContainer
 * @description This class is the main container of review and pay widget
 * and will make an API call. And pass on the Object to next level for painting the
 * Object.
 * @category Main Component
 */
class ReviewContainer extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    }
    /**
     * @function render
     * @description This function will be used to render the page in
     * With show more data by constructing the form from the incomming data
     * via API call
     */
    render() {
        const { reviewAndPayData } = this.props;
        let warrantyCost;
        if (reviewAndPayData && reviewAndPayData.residentialWarranty) {
            warrantyCost =
                reviewAndPayData.residentialWarranty.cost || reviewAndPayData.residentialWarranty.cost === 0
                    ? parseFloat(reviewAndPayData.residentialWarranty.cost)
                    : 0.0;
            warrantyCost = warrantyCost.toFixed(2);
        }
        let navMenuVal = -1;
        return (
            <div className="gaf-main-review-container ">
                {/* - provision for total cost can be used here - */}
                <div className="gaf-over-view-container justify-content-between">
                    <span className="overview-header">Overview</span>
                    <span className="totalcost">Total Warranty Cost: ${warrantyCost}</span>
                </div>

                {reviewAndPayData.residentialWarranty &&
                    //delete reviewAndPayData.residentialWarranty.cost &&
                    Object.keys(reviewAndPayData.residentialWarranty).map((items, index) => {
                        if (items != "cost") {
                            navMenuVal += 1;
                            return (
                                <ReviewCard
                                    key={`card ${index}`}
                                    titleinfo={items}
                                    cardindex={navMenuVal}
                                    content={reviewAndPayData.residentialWarranty[items]}
                                    tabIndex={100}
                                />
                            );
                        }
                    })}

                <div className="gaf-over-view-container-bottom justify-content-between warrany-cost">
                    <span className="totalcost">Total Warranty Cost: ${warrantyCost}</span>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        reviewAndPayData: state.myCartInfo.reviewData,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        myCartActions: bindActionCreators(myCartActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewContainer);
